import store from "../store";

export const SELECT_CAR = "SELECT_CAR";

const api = process.env.REACT_APP_API;

export const selectCar = car => {
  return function(dispatch) {
    dispatch(selectCarSuccess(car));
  };
};

export const REQUEST_AUTOS = "REQUEST_AUTOS";

export function requestAutos(filter) {
  return {
    type: REQUEST_AUTOS,
    payload: filter
  };
}

export const selectCarSuccess = response => {
  return {
    type: SELECT_CAR,
    car: response
  };
};

export const RECEIVE_AUTOS = "RECEIVE_AUTOS";

export function fetchAutos() {
  return function(dispatch) {
    dispatch(requestAutos());
    return fetch(api + "autos/modelos")
      .then(
        response => response.json(),
        error => console.log("An error occurred.", error)
      )
      .then(json => dispatch(receiveAutos(json)));
  };
}

export const RECEIVE_MODELO = "RECEIVE_MODELO";

export function fetchModelo(modelo) {
  return function(dispatch) {
    dispatch(requestAutos());
    return fetch(api + "autos/")
      .then(
        response => response.json(),
        error => console.log("An error occurred.", error)
      )
      .then(json => dispatch(receiveAutos(json)));
  };
}

function receiveAutos(json) {
  return {
    type: RECEIVE_AUTOS,
    autos: json.data,
    receivedAt: Date.now()
  };
}
